import * as React from "react";
import {
  Box,
  Button,
  Typography
} from "../../../components/mui";
import Modal from "../../../components/shared/Modal";
import { useToast } from "../../../components/shared/ToastProvider";

import "../../../styles/main.css";
import "../../../styles/pages/condoUnitDetail.css";

/**
 * ManageAttachmentModal
 * Simple UI-only modal for managing condo unit attachments.
 */
export default function ManageAttachmentModal({
  open,
  onClose,
  attachments = []
}) {
  const { showToast } = useToast();
  const [items, setItems] = React.useState(attachments);

  React.useEffect(() => {
    setItems(attachments);
  }, [attachments]);

  const handleAttach = () => {
    // UI-only feedback
    showToast({ message: "Attach clicked (UI only)", severity: "info" });
  };

  const handleRemove = (index) => {
    // UI-only: just update local state
    const next = items.filter((_, i) => i !== index);
    setItems(next);
    showToast({ message: "Attachment removed", severity: "success" });
  };

  const handleUpdate = () => {
    // UI-only: pretend we saved
    showToast({ message: "Attachments updated", severity: "success" });
    if (onClose) onClose();
  };

  const actions = (
    <>
      <Button variant="contained" onClick={handleUpdate}>
        Update
      </Button>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Manage Attachment"
      actions={actions}
      maxWidth="sm"
    >
      <Box className="modal-form-grid" style={{ marginTop: 8 }}>
        {/* File chooser row (UI only) */}
        <Box className="modal-form-row" display="flex" alignItems="center" gap={2}>
          <Button variant="outlined" component="label">
            Choose File
            <input type="file" hidden />
          </Button>
          <Typography variant="body2" color="textSecondary">
            No file chosen
          </Typography>
          <Button variant="contained" size="small" onClick={handleAttach}>
            Attach
          </Button>
        </Box>

        {/* Attachments list */}
        <Box className="modal-form-row">
          {items.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              No attachments
            </Typography>
          ) : (
            items.map((att, index) => (
              <Box
                key={`${att.file || att.name || "attachment"}-${index}`}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                className="modal-attachment-row"
              >
                <Button
                  variant="text"
                  size="small"
                  className="modal-attachment-link"
                >
                  {att.file || att.name}
                </Button>
                <Button
                  variant="text"
                  size="small"
                  color="error"
                  onClick={() => handleRemove(index)}
                >
                  Remove
                </Button>
              </Box>
            ))
          )}
        </Box>
      </Box>
    </Modal>
  );
}
